import React, { type PropsWithChildren } from 'react';
import { Button as AntButton, type ButtonProps as AntButtonProps } from 'antd';
import { ConfigProvider } from 'antd';
import { createPrimaryTheme, createSecondaryTheme, createDangerTheme } from '../../theme/antd-theme';

export type ButtonTheme = 'primary' | 'secondary' | 'danger';

interface CustomButtonProps {
  theme?: ButtonTheme;
  icon?: React.ReactNode;
}

interface ButtonProps extends AntButtonProps, CustomButtonProps {}

const Button: React.FC<PropsWithChildren<ButtonProps>> = ({ children, theme = 'primary', className = '', icon, type, ...props }) => {
  const getThemeConfig = () => {
    switch (theme) {
      case 'secondary':
        return createSecondaryTheme();
      case 'danger':
        return createDangerTheme();
      default:
        return createPrimaryTheme();
    }
  };

  const getButtonType = () => {
    if (type) return type;
    return theme === 'secondary' ? 'default' : 'primary';
  };

  const customClassName = theme === 'primary' && (type === 'text' || type === 'default') ? `button-primary-${type} ${className}`.trim() : className;

  return (
    <ConfigProvider theme={getThemeConfig()}>
      <AntButton
        type={getButtonType()}
        className={customClassName}
        icon={icon}
        {...props}
      >
        {children}
      </AntButton>
    </ConfigProvider>
  );
};

export default Button;

